import React from 'react';
import Ap from '../containers/ApContainer';

const ApAppClient = (props) => (
  <Ap {...props} />
);

export default ApAppClient;
